export const updateCheckboxFromFilter = (currentAction, creator, store) => {
  const {
    payload: {
      filters: { hasHot, hasOptions },
    },
  } = currentAction
  const checkboxFilters = { hasHot, hasOptions }
  for (const key in checkboxFilters) {
    if (checkboxFilters[key]) {
      return store.dispatch(creator(key))
    }
  }
  return store.dispatch(creator())
}
